"use client";
import { useEffect } from "react";
/* https://github.com/streamich/react-use/blob/master/src/useEvent.ts */
export const useEventListener = (name, handler, target = typeof window !== "undefined" ? window : null) => {
    useEffect(() => {
        if (!target) {
            return;
        }
        target === null || target === void 0 ? void 0 : target.addEventListener(name, handler);
        return () => {
            target === null || target === void 0 ? void 0 : target.removeEventListener(name, handler);
        };
    }, [name, handler, target]);
};
//# sourceMappingURL=useEventListener.js.map